import { create } from 'zustand';

type FilterState = {
  filters: Record<string, any>;
  setFilters: (filters: Record<string, any>) => void;
  clearFilters: () => void;
};

export const useFilterStore = create<FilterState>((set) => ({
  filters: {},
  setFilters: (filters) => set(() => ({ filters })),
  clearFilters: () => set(() => ({ filters: {}, searchQuery: '', results: [] }))
}));
